const getItemDetailAfterDiscount: any = (
  orderAmount: number, 
  orderDiscount: number, 
  itemTotalPrice: number, 
  itemVat: number
) => {
  let pc = 100*(itemTotalPrice)/orderAmount;
  let discountOnItem = orderDiscount*pc/100;
  let finalTotalPrice = itemTotalPrice - discountOnItem;

  return {
    price: finalTotalPrice,
    tax: finalTotalPrice*itemVat/100
  }
}
export default getItemDetailAfterDiscount;